<template>
  <section>
    <h1>Подписание "КИД"</h1>
    <p class="faq__clientText">
      Уважаемый клиент!
      <br><br>
      Перед подписанием договора страхования необходимо ознакомиться с «Ключевым информационным документом об условиях
      договора добровольного страхования» (далее – КИД).
    </p>
    <div class="faq__pdf">
      <a :href="project_link" target="_blank">Проект договора</a>
      <a :href="kid_link" :aria-disabled="!kid_link" :class="{disabled: !kid_link}" target="_blank">КИД</a>
    </div>
    <div class="faq__checkbox">
      <input v-model="active" id="checkRules" type="checkbox" value="" />
      <label for="checkRules">Я ознакомлен и согласен с «Ключевым информационным документом об условиях договора
        добровольного страхования».
      </label>
    </div>
    <span class="faq__text">
      Для подписания КИД введите смс-код, направленный Вам на указанный Вами номер телефона.
    </span>
    <sms-component
      :active="active"
      :view="'kid'"
      :contract_id="contract_id"
      :other_params="{type:'contract_kid'}"
      @signed="signed"
    />
  </section>
</template>

<script>
import SmsComponent from "@/profile/components/SmsComponent.vue";
import axios from "axios";
import { url } from "@/profile/composables/url";

export default {
  name: "KidComponents",
  props: ["contract_id", "project_link"],
  data: () => {
    return {
      kid_link: false,
      active: false
    };
  },
  mounted() {
    let $this = this;
    let params = {
      command: "kid_url",
      policy_id: this.contract_id,
      token: this.$myApp.token.get()
    };
    this.send(params)
      .then(function(response) {
        let data = response.data;
        if (data.state === "ERR") {
          $this.errors = [];
          $this.errors.push(data.msg_text);
        }
        if (data.state === "OK") {
          $this.kid_link = data.url;
        }
      });
  },
  methods: {
    send(params) {
      return axios
        .post(url, { params: params });
    },
    signed() {
      // this.$router.push({ name: 'constructor'});
      location.reload();
    }
  },
  components: {
    SmsComponent
  }
};
</script>

<style scoped>

</style>